import PersistentStore from "@/api/PersistentStore";
import { RootState } from "@/store/types";
import _ from "lodash";
import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { ProfileState } from "./types";

export const AREA_LIST_KEY = "area";
export const AUDIO_ALERTS_ENABLED_KEY = "enableAudioAlerts";
export const ALERT_REPEAT_INTERVAL_KEY = "alertRepeatInterval";
export const PREFERENCES_KEY = "AW_PREFERENCES_KEY";

export const initialState = function(): ProfileState {
  const audioAlertsEnabled = PersistentStore.getItem(
    AUDIO_ALERTS_ENABLED_KEY,
    false
  );

  const alertRepeatInterval = PersistentStore.getItem(
    ALERT_REPEAT_INTERVAL_KEY,
    0
  );

  const preferences = PersistentStore.getItem(PREFERENCES_KEY, {});

  const areaList = PersistentStore.getItem(AREA_LIST_KEY, []);

  let area = "";
  // Only use default area if there is only 1 in the list
  // otherwise let the user always pick
  if (_.isArray(areaList) && areaList.length === 1) {
    area = areaList[0];
  }

  return {
    data: {
      name: "",
      mask: false,
      permanentMask: false,
      canEdit: false,
      browser: "",
      computer: "",
      hasCases: false,
      hash: "",
      ip: "",
      mode: "",
      rights: [],
      isAdmin: false,
      areas: [],
      room: "",
      unit: "",
      route: "",
      sessionStart: "",
      status: 0,
      userID: "",
      email: "",
      pagerID: "",
      isTesting: false,
      isActiveTesting: false
    },
    error: false,
    accessRequestResult: {},
    system: {},
    systemLoaded: false,
    area,
    audioAlertsEnabled,
    alertRepeatInterval,
    speechSynthesisEnabled: false,
    preferences,
    hasShownLoginMs: false,
    activeTestList: []
  };
};

export const state: ProfileState = initialState();

export const userNamespace = { namespace: "user" };

export const enum Permission {
  ADMIN = "Admin",
  NO_EDIT = "NoEdit",
  TOWER = "Tower",
  PATIENT = "Patient"
}

const namespaced: boolean = true;

export const user: Module<ProfileState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
